<template>
  <div class="component-sidebar">
    <div class="component-item" v-for="component of components" :key="component.type" draggable="true"
      @dragstart="onDragStart(component)">
      <HtmlComponent :component="component" :interactable="false" />
    </div>
  </div>
</template>

<script>
import HtmlComponent from "../form-components-html/HtmlComponent.vue";

const ALL_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'
];

export default {
  name: "ComponentSidebarV2",
  data() {
    return {
      components: [
        {
          type: "HEADER",
          label: "Header",
          headerSize: 'h1'
        },
        {
          type: "PARAGRAPH",
          label: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        },
        {
          type: "TEXT",
          label: "Text Box",
        },
        {
          type: "TEXTAREA",
          label: "Long Response"
        },
        {
          type: 'DATE',
          label: 'Date Field',
        },
        {
          type: "EMAIL",
          label: "Email Field",
        },
        {
          type: "PHONE",
          label: "Phone Field",
        },
        {
          type: "FILE",
          label: "File Upload Field"
        },
        {
          type: "NUMBER",
          label: "Number Box",
        },
        {
          type: "DROPDOWN",
          label: "Dropdown",
          options: ['Option 1', 'Option 2', 'Option 3']
        },
        {
          type: "MULTISELECT",
          label: "Multi-Select",
          options: ['Option 1', 'Option 2', 'Option 3']
        },
        {
          type: "SSN",
          label: "Social Security Number",
        },
        {
          type: "SIGNATURE",
          label: "Patient Signature",
          signatureType: 'signature-patient'
        },
        {
          type: 'CHECKBOX',
          label: 'Checkbox With Label',
          optional: true
        },
        {
          type: 'SPACER',
          label: 'Spacer'
        },
        {
          type: "STATE",
          label: "U.S. State",
          options: ALL_STATES
        },
        {
          type: 'IMAGE',
          label: 'Image',
          width: 300,
          height: 200
        }
      ],
    };
  },
  methods: {
    onDragStart(component) {
      const newComponent = {
        ...component,
        key: this.generateRandomId('doNotImport')
      }

      this.$emit('onDragStart', newComponent)
    },
    generateRandomId(prefix) {
      return prefix + Math.random().toString(16).substring(2)
    }
  },
  components: { HtmlComponent },
  emits: ['onDragStart', 'onDragEnd']
};
</script>

<style scoped>
.component-sidebar {
  flex-basis: 350px;
  height: 100%;
  overflow-y: auto;
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  display: flex;
  flex-direction: column;
  padding: 15px;
  gap: 15px;
  /* Firefox */
}

.component-sidebar::-webkit-scrollbar {
  display: none;
}

.component-item {
  padding: 20px;
  background: #FFF;
  border-radius: 10px;
  box-shadow: 0px 0px 8px #00000022;
  cursor: grab;
}

.component-item>div {
  pointer-events: none;
}

.row-columns>.component {
  margin-left: 25px;
}
</style>